function Validator_ajax(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]'
    };

    this.data = {
	    required: 'required',
	    messageFail: 'message-fail',
	    plugin: 'plugin',
	    action: 'action',
	    parameterValue: 'parameter-value',
	    parameterField: 'parameter-field',
		validateOnSubmit: 'validate-on-submit'
    };

    this.triggers = {
	    validate: 'i4:validate',
	    updateView: 'i4:updateView',
	    refresh: 'i4:refresh'
    };

    this.classNames = {
	    failMessage: 'fail-message'
    };

    this.init = function() {

	    // console.log('init - ajax');

	    this.$formParent = this.$element.parents(this.selectors.formParent);

	    this.dataRequired = this.$element.data(this.data.required);
	    this.dataMessageFail = this.$element.data(this.data.messageFail);

	    this.dataPlugin = this.$element.data(this.data.plugin);
	    this.dataAction = this.$element.data(this.data.action);
	    this.dataParameterValue = this.$element.data(this.data.parameterValue);
	    this.dataParameterField = this.$element.data(this.data.parameterField);

	    this.$formParent.trigger(this.triggers.refresh);

	    this.$element.on(this.triggers.validate, this.validate.bind(this));
	    this.$element.on('keyup blur change', this.$elementChange.bind(this));

	    $.each(this.dataParameterField, (function(key, value) {
		    this.$formParent.find('#'+value).on('keyup blur change', this.$elementChange.bind(this));
	    }).bind(this));

		this.validateOnSubmit = this.$formParent.length && this.$formParent.data(this.data.validateOnSubmit);
		this.prepareFailMessage();

		if (!this.validateOnSubmit) {
			this.validate();
		}
    };

    this.$elementChange = function() {
	    this.validate();
	    this.$element.trigger('i4:change');

	    this.$formParent.trigger(this.triggers.updateView);
    };

    this.validate = function() {
	    this.value = this.$element.val();

	    var parameterList = {};

	    $.each(this.dataParameterValue, function(key, value) {
		    parameterList[key] = encodeURIComponent(value);
	    });

	    $.each(this.dataParameterField, (function(key, value) {
		    parameterList[key] = this.$formParent.find('#'+value).val();
	    }).bind(this));

	    var parameter = 'js='+this.dataPlugin+'&call='+this.dataAction+'&value='+encodeURIComponent(this.value)+(parameterList.length == 0 ? '' : '&'+jQuery.param(parameterList));

		if (parameter !== this.lastParameter) {
			this.lastParameter = parameter;

			this.$element.addClass('loading');
			this.$element.addClass('invalid');

		    i4_Ajax.factory().
				set_parameter(parameter).
				set_option({
					on_success: (function(responseText) {
						var isValid = (responseText == 1);

						this.$element.removeClass('invalid');
						this.$element.removeClass('valid');
						this.$element.removeClass('loading');
						this.$failMessage.hide();

						if (isValid) {
							this.$element.addClass('valid');
						} else if (this.value != '' || this.dataRequired) {
							this.$element.addClass('invalid');

							if (this.validateOnSubmit || this.value != '') {
								this.$failMessage.show();
							} else {
								this.$failMessage.hide();
							}
						}

						this.$formParent.trigger(this.triggers.updateView);

					}).bind(this)
				}).
				run();
	    }
    };

    this.prepareFailMessage = function() {
	    this.$failMessage = $('<div></div>');

	    if (this.dataMessageFail !== undefined) {
		    this.$failMessage.
		    	addClass(this.classNames.failMessage).
		    	html(this.dataMessageFail).
		    	hide();

		    this.$element.after(this.$failMessage);
	    }
    };

}

